import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=8017ed48&scoped=true"
import script from "./addClass.vue?vue&type=script&lang=ts"
export * from "./addClass.vue?vue&type=script&lang=ts"
import style0 from "./addClass.vue?vue&type=style&index=0&id=8017ed48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8017ed48",
  null
  
)

export default component.exports